export const CLASSNAME = 'multi-reactions';
